export default __webpack_public_path__ + "333f19f60d9c05b544a5b7a8d5d6e7ba.svg";